import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BrandService } from 'src/app/services/brand.service';

@Component({
  standalone: false,
  selector: 'app-brands-add',
  templateUrl: './brands-add.component.html',
})
export class BrandsAddComponent {
  form: any = {
    name: '',
    sap_brand_id: '',
    status: 1,
  };
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private brandService: BrandService,
  ) {}

  submit(): void {
    this.validationTriggered = true;
    if (!this.form.name) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      name: this.form.name,
      sap_brand_id: this.toNullableInt(this.form.sap_brand_id),
      status: Number(this.form.status),
    };

    this.brandService.create(payload).subscribe({
      next: (result) => {
        this.toaster.success('Brand added.');
        this.router.navigate(['/ecomm/brands', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add brand.');
      },
    });
  }

  onSapBrandIdInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    this.form.sap_brand_id = digits;
    if (input.value !== digits) {
      input.value = digits;
    }
  }

  /** Empty → null (avoid Number(null) === 0). */
  private toNullableInt(value: unknown): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
